import type { Job } from '../../api/tipos';
import type { TomEtiqueta } from '../../componentes/ui';
import { numero } from '../../util/formato';

/**
 * Traduz o estado de um job para a etiqueta da interface.
 *
 * `CONCLUIDO` não é necessariamente sucesso limpo: um lote pode terminar com
 * chaves que a fonte não conhece (esperado) ou com falhas depois de esgotar as
 * retentativas (não esperado). Mostrar "concluída" nos dois casos esconderia
 * justamente o que o usuário precisa ver.
 */
export function etiquetaDoJob(job: Job): {
  texto: string;
  tom: TomEtiqueta;
  pulsando?: boolean;
} {
  switch (job.status) {
    case 'PENDENTE':
      return { texto: 'Na fila', tom: 'neutro', pulsando: true };
    case 'PROCESSANDO':
      return { texto: 'Baixando', tom: 'info', pulsando: true };
    case 'ERRO':
      return { texto: 'Falhou', tom: 'erro' };
    case 'CONCLUIDO':
      if (job.erro > 0) return { texto: 'Concluída com falhas', tom: 'erro' };
      if (job.notfound > 0) {
        return {
          texto: `${numero(job.notfound)} não ${job.notfound === 1 ? 'encontrada' : 'encontradas'}`,
          tom: 'alerta',
        };
      }
      return { texto: 'Concluída', tom: 'ok' };
  }
}

/** Um job que já terminou não vale mais pesquisar por atualização. */
export function terminou(job: Job): boolean {
  return job.status === 'CONCLUIDO' || job.status === 'ERRO';
}
